module.exports = __webpack_public_path__ + "static/img/aunna_logo.e049e80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aunna_logo.png
// module id = x4iX
// module chunks = 1